import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useLogout = (): ReturnType<typeof useApiMutation> => useApiMutation(RESOURCES.LOGOUT, CLIENT_METHODS.POST)
